import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'header-profile',
    templateUrl: 'header-profile.component.html',
    styleUrls: ['header-profile.component.scss'],
    standalone: false
})
export class HeaderProfileComponent {
	@Input() userName: string = '';
	@Input() userEmail: string = '';
	@Input() userNameInitialLetters: string = '';

	@Output() profileClick = new EventEmitter<void>();
	@Output() helpClick = new EventEmitter<void>();
	@Output() logoutClick = new EventEmitter<void>();

	public onProfileClick(): void {
		this.profileClick.emit();
	}

	public onHelpClick(): void {
		this.helpClick.emit();
	}

	public onLogoutClick(): void {
		this.logoutClick.emit();
	}
}
